import { AppShell, Button, ButtonGroup, Flex, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthLoggedIn } from '../providers/AuthProvider.tsx';

const Guest = () => {
  const { i18n } = useTranslation();
  const isLoggedIn = useAuthLoggedIn();

  const changeLanguage = (lng: any) => {
    i18n.changeLanguage(lng).catch(() => {
      // Error changing language
    });
  };

  // This check is now handled at App level, but keeping as fallback
  if (isLoggedIn) {
    return <Navigate to='/' replace />;
  }

  return (
    <AppShell header={{ height: 60 }} padding='md'>
      <AppShell.Header p={'sm'}>
        <Flex align={'center'} justify={'space-between'} style={{ height: 40 }}>
          <Title order={4}>BECOME.</Title>
          <ButtonGroup>
            <Button
              variant={'subtle'}
              onClick={() => changeLanguage('en')}
              disabled={i18n.language === 'en'}
            >
              English
            </Button>
            <Button
              variant={'subtle'}
              onClick={() => changeLanguage('it')}
              disabled={i18n.language === 'it'}
            >
              Italiano
            </Button>
            <Button
              variant={'subtle'}
              onClick={() => changeLanguage('pt')}
              disabled={i18n.language === 'pt'}
            >
              Português
            </Button>
          </ButtonGroup>
        </Flex>
      </AppShell.Header>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};

export default Guest;
